/* global questionForm */
import '../javascripts/selmodal.js';
import NextFieldHint from "./next_field_hint";
import AutoInputItemName from "./auto_input_item_name";
import FieldLabelHint from "./field_label_hint";
import LoadingAnimation from "./loading_animation";
import Rails from 'rails-ujs';
import jQuery from 'jquery';

$(() => {
  // よくある質問のアコーディオン
	$(".question").on("click", function () {
    $(this).next().stop().slideToggle();
    $(this).stop().toggleClass('active');
  });
});

window.addEventListener('load', () => {
  const publishButton = Rails.$('#publish_button')[0];
  const activateBlowserAlert = document.getElementsByClassName('item-new_form');
  if (activateBlowserAlert[0]) {
    if (activateBlowserAlert[0].dataset.itemNew == "true") {
      // ref: https://developer.mozilla.org/ja/docs/Web/Events/beforeunload
      window.addEventListener("beforeunload", showBlowserAlert, false);
    }
  }
  function showBlowserAlert(event) {
    event.preventDefault();
    event.returnValue = ""; // chrome対応
  }
  if(publishButton){
    document.getElementById('publish_button').addEventListener('click', () => {
      window.removeEventListener("beforeunload", showBlowserAlert, false);
    });

    document.getElementById('publish_button').addEventListener('submit', () => {
      publishButton.style = 'pointer-events: none;';
    });
  }
});

window.addEventListener('load', () => {
  // 「初めての方へ」をクリックした時に、ポップアップを表示する。
  // sliderがhideをつけた状態でレンダリングが上手くいかないため、opacity_zeroを使用している。
  const el = document.getElementById('how_to_pix');
  const opacityZeroBlock = Rails.$('.opacity_zero')[0];

  if(el && opacityZeroBlock){
    el.classList.add('hide');
    el.classList.remove('opacity_zero');
  }
});

// 買取の流れページでボタンを押すと買取方法のスライドを表示させる
window.addEventListener('load', () => {
  // sliderがhideをつけた状態でレンダリングが上手くいかないため、opacity_zeroを使用している。
  const el = document.getElementById('purchase_options_slides');
  const opacityZeroBlock = Rails.$('.opacity_zero')[0];

  if(el && opacityZeroBlock){
    el.classList.add('hide');
    el.classList.remove('opacity_zero');
  }
});

// 買取の流れページで買取金受けとり方法ボタンを押すと買取金受け取り方法のスライドを表示させる
window.addEventListener('load', () => {
  // sliderがhideをつけた状態でレンダリングが上手くいかないため、opacity_zeroを使用している。
  const el = document.getElementById('receive_options_slides');
  const opacityZeroBlock = Rails.$('.opacity_zero')[0];

  if(el && opacityZeroBlock){
    el.classList.add('hide');
    el.classList.remove('opacity_zero');
  }
});

// 大手送客用の商品詳細ページにて、最新の取引メモを15秒おきに非同期で取得、表示
window.addEventListener('load', () => {
  const selector = '.organization_note_ex';
  const url = location.href;
  const elem = document.querySelector(selector);
  if (elem !== null) {
    setInterval(() => {
      updateNoteEx(url, elem, selector);
    }, 15000);
  }
});

// 最新の取引メモを非同期で取得、表示
function updateNoteEx(url, elem, selector) {
  // ajax通信でHTMLデータを取得
  url = `${url}?ver=${new Date().getTime()}`;
  const ajax = new XMLHttpRequest;
  ajax.open('GET', url, true);

  // ajax返信時の処理
  ajax.onload = function() {
    // 取得したデータから特定の要素のみ抽出し、非同期で書き換え
    const tmp = document.createElement('div');
    tmp.setAttribute('id', 'tmp_div');
    tmp.style.display = 'none';
    const tmp_div = document.querySelector('#tmp_div');
    if (!tmp_div) {
      document.querySelector('body').appendChild(tmp);
    }
    tmp.innerHTML = ajax.responseText;
    elem.innerHTML = tmp.querySelector(selector).innerHTML;
    tmp.innerHTML = '';
  };

  // ajax開始
  ajax.send(null);
}

import Vue from 'vue/dist/vue.esm';
import axios from 'axios';

let productCategoryVm;

window.addEventListener('load', () => {
  const categorySelectBlock = Rails.$('.product_category')[0];

  if(!categorySelectBlock){
    return;
  }

  productCategoryVm = new Vue({
    el: categorySelectBlock,
    data: {
      productCategories1: [{id: '', name: '選択してください'}],
      productCategories2: [{id: '', name: '選択してください'}],
      productCategories3: [{id: '', name: '選択してください'}]
    },
    props: [
      'productCategories0'
    ],
    methods: {
      productCategories0Changed(e){
        this.fetchProductCategories1(e.target.value);
        this.toggleSelectFieldHint();
        this.clearSelectorValues();
        window.updateButtonByCheckAllRequiredValues();
      },
      fetchProductCategories1(categoryId){
        LoadingAnimation.startWaitingSpinner();
        axios.get(`/pix/api/public/product_categories?id=${categoryId}`).then(
          (res) => {
            const productCategorySelect1 = Rails.$('#productCategorySelect1')[0];

            if (res.data.length > 0) {
              this.productCategories1 = [{id: '', name: '選択してください'}].concat(res.data);
              productCategorySelect1.classList.add('required');
              productCategorySelect1.selectedIndex = 0;
              Rails.$('#productCategorySelectBlock1')[0].classList.remove('hidden');
              // LP2画面のみ親カテゴリの値が入力された時に赤枠を表示する
              NextFieldHint.addProductCategorySelectBlock("1");
              FieldLabelHint.toggleLpPageRequiredLabel(false);

              const defaultValue = productCategorySelect1.getAttribute('default-value');
              if(defaultValue){
                this.fetchProductCategories2(defaultValue);
                productCategorySelect1.setAttribute('default-value', '');
              }
            }else{
              Rails.$('#productCategorySelectBlock1')[0].classList.add('hidden');
              productCategorySelect1.classList.remove('required');
              // LP2画面のみ商品名フィールドに赤枠を表示
              NextFieldHint.addItemNameFieldHint();
              FieldLabelHint.toggleLpPageRequiredLabel(self.productCategorySelect0.value !== '');
              this.autoInputItemName();
            }

            Rails.$('#productCategorySelectBlock2')[0].classList.add('hidden');
            Rails.$('#productCategorySelectBlock3')[0].classList.add('hidden');
            LoadingAnimation.endWaitingSpinner();
            // axios完了時点で productCategorySelect1 の value/required が変化しているので
            // 送信ボタンの活性状態を再評価する
            window.updateButtonByCheckAllRequiredValues();
          }
        );
      },
      productCategories1Changed(e){
        this.fetchProductCategories2(e.target.value);
        this.toggleSelectCheckIcon();
        this.toggleSelectFieldHint();
        this.autoInputItemName();
        window.updateButtonByCheckAllRequiredValues();
      },
      fetchProductCategories2(categoryId){
        LoadingAnimation.startWaitingSpinner();
        axios.get(`/pix/api/public/product_categories?id=${categoryId}`).then(
          (res) => {
            const productCategorySelect2 = Rails.$('#productCategorySelect2')[0];

            if (res.data.length > 0) {
              this.productCategories2 = [{id: '', name: '選択してください'}].concat(res.data);

              productCategorySelect2.classList.add('required');
              productCategorySelect2.selectedIndex = 0;
              Rails.$('#productCategorySelectBlock2')[0].classList.remove('hidden');
              // LP2画面のみ親カテゴリの値が入力された時に赤枠を表示する
              NextFieldHint.addProductCategorySelectBlock("2");
              FieldLabelHint.toggleLpPageRequiredLabel(false);

              const defaultValue = productCategorySelect2.getAttribute('default-value');
              if(defaultValue) {
                this.fetchProductCategories3(defaultValue);
                productCategorySelect2.setAttribute('default-value', '');
              }
            } else {
              productCategorySelect2.classList.remove('required');
              Rails.$('#productCategorySelectBlock2')[0].classList.add('hidden');
              // LP2画面のみ商品名フィールドに赤枠を表示する
              NextFieldHint.addItemNameFieldHint();
              FieldLabelHint.toggleLpPageRequiredLabel(self.productCategorySelect1.value !== '');
            }

            Rails.$('#productCategorySelectBlock3')[0].classList.add('hidden');
            LoadingAnimation.endWaitingSpinner();
            // axios完了時点で productCategorySelect2 の value/required が変化しているので
            // 送信ボタンの活性状態を再評価する
            window.updateButtonByCheckAllRequiredValues();
          }
        );
      },
      productCategories2Changed(e){
        this.fetchProductCategories3(e.target.value);
        this.toggleSelectCheckIcon();
        this.toggleSelectFieldHint();
        this.autoInputItemName();
        window.updateButtonByCheckAllRequiredValues();
      },
      fetchProductCategories3(categoryId){
        LoadingAnimation.startWaitingSpinner();
        axios.get(`/pix/api/public/product_categories?id=${categoryId}`).then(
          (res) => {
            const productCategorySelect3 = Rails.$('#productCategorySelect3')[0];

            if (res.data.length > 0) {
              this.productCategories3 = [{id: '', name: '選択してください'}].concat(res.data);

              productCategorySelect3.selectedIndex = 0;
              productCategorySelect3.classList.add('required');
              Rails.$('#productCategorySelectBlock3')[0].classList.remove('hidden');
              // LP2画面のみ親カテゴリの値が入力された時に赤枠を表示する
              NextFieldHint.addProductCategorySelectBlock("3");
              FieldLabelHint.toggleLpPageRequiredLabel(false);
            } else {
              productCategorySelect3.classList.remove('required');
              Rails.$('#productCategorySelectBlock3')[0].classList.add('hidden');
              // LP2画面のみ商品名フィールドに赤枠を表示する
              NextFieldHint.addItemNameFieldHint();
              FieldLabelHint.toggleLpPageRequiredLabel(self.productCategorySelect2.value !== '');
            }
            LoadingAnimation.endWaitingSpinner();
            // axios完了時点で productCategorySelect3 の value/required が変化しているので
            // 送信ボタンの活性状態を再評価する
            window.updateButtonByCheckAllRequiredValues();
          }
        );
      },
      productCategories3Changed(){
        this.toggleSelectCheckIcon();
        this.toggleSelectFieldHint();
        this.autoInputItemName();
        window.updateButtonByCheckAllRequiredValues();
      },
      toggleSelectCheckIcon() {
        Rails.$('.product_category_select').forEach(
          (element) => {
            if (element.tagName != 'SELECT') { return; }

            const haveValue = element.options[element.selectedIndex].value != '';
            const checkIcon = element.parentElement.nextElementSibling;

            if (!checkIcon) { return; }

            if (haveValue) {
              checkIcon.classList.remove('hidden');
            } else {
              checkIcon.classList.add('hidden');
            }
          }
        );
      },
      clearSelectorValues() {
        self.productCategorySelect1.value = '';
        self.productCategorySelect2.value = '';
        self.productCategorySelect3.value = '';
      },
      toggleSelectFieldHint(){
        // LP2画面のみ親カテゴリの値が入力された時に赤枠を表示する
        if (!(NextFieldHint.approveFieldHintUrl())) return;

        Rails.$('.product_category_select').forEach((element) => {
            if (element.tagName !== 'SELECT') return;

            const selectCategory = element.options[element.selectedIndex];

            const nonSelectedCategory = selectCategory.value !== '';

            if(nonSelectedCategory){
              element.nextElementSibling.classList.remove('field_hint');
            } else {
              element.nextElementSibling.classList.add('field_hint');
            }
          }
        );
      },
      autoInputItemName(){
        AutoInputItemName.buildItemNameValue();
      }
    },
    mounted(){
    },
    updated(){
      this.toggleSelectCheckIcon();
      jQuery('.selmodal').selModal();
      window.updateButtonByCheckAllRequiredValues();
    }
  });
});

window.addEventListener('load', () => {
  const categorySelectBlock = Rails.$('.category_select')[0];

  if(!categorySelectBlock){ return; }

  new Vue({
    el: categorySelectBlock,
    data: {
      childCategories: []
    },
    methods: {
      loadChildCategories(){
        if (!this.$refs.parentCategory){ return; }
        if (this.$refs.parentCategory.value != '') {
          LoadingAnimation.startWaitingSpinner();
          axios.get(`/pix/api/public/categories?parent_category_id=${this.$refs.parentCategory.value}`).then(
            (res) => {
              const childCategory = Rails.$('.child_categories')[0];
              const checkIcon = childCategory.lastElementChild;

              if (res.data.length > 0) {
                this.childCategories = [{id: '', name: '選択してください'}].concat(res.data);
                childCategory.style = 'display: block;';
                // 選択されている子カテを初期値(「選択してください」)に戻す
                document.getElementById('item_child_category_id').selectedIndex = 0;
                checkIcon.classList.add('hidden');
              } else {
                this.childCategories = [];
                childCategory.style = 'display: none;';
              }
              LoadingAnimation.endWaitingSpinner();
            }
          );
        } else {
          Rails.$('.child_categories')[0].style = 'display: none;';
          this.childCategories = [];
        }

        const productCategoryBlock = Rails.$('.product_category')[0];
        if(!productCategoryBlock.classList.contains('hidden')){
          productCategoryBlock.classList.add('hidden');
        }
        const productCategorySelectBlock0 = Rails.$(`#productCategorySelectBlock0`)[0];
        if(!productCategorySelectBlock0.classList.contains('hidden')){
          productCategorySelectBlock0.classList.add('hidden');
        }

        [0, 1, 2, 3].forEach(
          (i) => {
            Rails.$(`#productCategorySelect${i}`)[0].classList.remove('required');
            Rails.$(`#productCategorySelectBlock${i}`)[0].classList.add('hidden');
          }
        );

        if (window.updateButtonByCheckAllRequiredValues){
          window.updateButtonByCheckAllRequiredValues();
        }
      },
      // 親カテが選択された時に画像が必須であることを表示しrequiredを付与する
      toggleItemImageRequired() {
        const imagesForm = document.querySelector('.images_form span');
        const label = imagesForm.querySelector('#item_image_form_label');
        // 新規モード（分離UI）では .image-hidden-primary、編集モード（旧UI）では .image_hidden を対象とする
        const imagesHidden = document.querySelector('.image-hidden-primary') || document.querySelector('.image_hidden');

        imagesHidden?.classList.add('image_required', 'first_step_required');
        label.style.display = 'inline-block';
      },
      toggleModelNumberField(parentCategoryName, childCategoryName) {
        const TARGET_PARENT_CATEGORY_LABELS = ['スマホ・カメラ・家電・オーディオ・スピーカー', 'ブランドバッグ・高級時計'];
        const TARGET_CHILD_CATEGORY_LABELS = ['カメラ', '高級時計'];

        const isTargetParentCategory = TARGET_PARENT_CATEGORY_LABELS.some((label) => label == parentCategoryName);
        const isTargetChildCategory = TARGET_CHILD_CATEGORY_LABELS.some((label) => label == childCategoryName);
        const modelNumberField = document.getElementById('model_number_field');

        if (isTargetParentCategory && isTargetChildCategory) {
          modelNumberField.classList.remove('hidden');
        } else {
          // 楽器LPの場合はModelNumberFiledが存在しないのでreturnする
          const gakkiLp = document.getElementById('gakkiLp');
          if (gakkiLp !== null) {return;}
          modelNumberField.classList.add('hidden');
        }
      },
      // 型番非対象カテゴリへ「ユーザーが切り替えた」時に value をクリアする。
      // mounted/updated からは呼ばず、parent/child select の @change 経由でのみ呼ぶこと。
      // mounted/updated で呼ぶと、編集画面で「非ターゲットカテゴリ × 既存 model_number 値」のレコードを
      // ロードしただけで value が消え、無関係なフィールドの編集→保存で既存データを破壊する。
      // toggleModelNumberField の判定結果は DOM の hidden クラスに反映されているのでそれを参照し、
      // ターゲット判定の定数を二重管理しないようにする。@change チェーンで toggleModelNumberField の後に呼ぶ前提。
      clearModelNumberIfNotTarget() {
        const modelNumberField = document.getElementById('model_number_field');
        if (!modelNumberField || !modelNumberField.classList.contains('hidden')) return;

        const modelNumberInput = document.getElementById('item_model_number');
        if (modelNumberInput) { modelNumberInput.value = ''; }
        // value を空にしても keyup は発火せず緑チェックが残るため、入力済みインジケータも合わせて隠す。
        // （対象→入力→非対象→対象に戻した時に「空なのに緑チェック」が出る不整合を防ぐ）
        modelNumberField.querySelector('.check_icon')?.classList.add('hidden');
      },
      toggleUserTelRequired(parentCategoryName, childCategoryName) {
        const itemTel = document.getElementById('item_tel');
        if (!itemTel) {return;}

        const TARGET_PARENT_CATEGORY_LABELS = ['スマホ・カメラ・家電・オーディオ・スピーカー', 'ホビー・おもちゃ', 'ブランドバッグ・高級時計', '着物・美術品・骨董品', 'ピアノ・楽器・PA機材', 'スポーツ・アウトドア', 'お酒・喫煙具', '金・ジュエリー'];
        const TARGET_CHILD_CATEGORY_LABELS = ['PC・タブレット', 'オーディオ・スピーカー', '家電', 'エアガン・ミリタリー用品', '鉄道模型・プラレール', '高級時計', '美術品・骨董品', '釣具', 'アウトドア用品', 'その他のスポーツ用品','ブランドバッグ', 'お酒', '金・貴金属', '宝石'];

        const isTargetParentCategory = TARGET_PARENT_CATEGORY_LABELS.some((label) => label == parentCategoryName);
        const isTargetChildCategory = TARGET_CHILD_CATEGORY_LABELS.some((label) => label == childCategoryName);
        const telIconLabel = document.getElementById('tel-icon-label');

        if (isTargetParentCategory && isTargetChildCategory) {
          itemTel.classList.add('required', 'first_step_required');
          itemTel.setAttribute('minlength', '6');
          telIconLabel.classList.add('icon_label_black');
          telIconLabel.classList.remove('hidden');
        }
      },
      getSelectedParentLabel() {
        const itemParentCategory = this.$refs.parentCategory;
        const selectedParentCategory = itemParentCategory.options[itemParentCategory.selectedIndex];

        if (selectedParentCategory) {
          return selectedParentCategory.text;
        }
      },
      getSelectedParentShortName() {
        const itemParentCategory = this.$refs.parentCategory;
        const selectedParentCategory = itemParentCategory.options[itemParentCategory.selectedIndex];

        if (selectedParentCategory) {
          return selectedParentCategory.dataset.shortName;
        }
      },
      getSelectedChildLabel() {
        const itemChildCategory = document.getElementById('item_child_category_id');
        const selectedChildCategory = itemChildCategory.options[itemChildCategory.selectedIndex];

        if (selectedChildCategory) {
          return selectedChildCategory.text;
        }
      },
      getSelectedChildShortName() {
        const itemChildCategory = document.getElementById('item_child_category_id');
        if (!itemChildCategory) { return; }

        const selectedChildCategory = itemChildCategory.options[itemChildCategory.selectedIndex];
        if (!selectedChildCategory || selectedChildCategory.value === '') { return; }

        return selectedChildCategory.dataset.shortName;
      },
      // 古着・ファッションカテゴリ選択時に「その他の写真」エリアに注釈を表示する
      toggleFashionCategoryNote(categoryShortName) {
        const additionalSection = document.querySelector('.image-upload-additional');
        if (!additionalSection) return;

        additionalSection.classList.toggle('show-furugi-note', categoryShortName === 'furugi');
      },
      displayCheckIcon() {
        const checkIcon = Rails.$('.child_categories')[0].lastElementChild;

        if (document.getElementById('item_child_category_id').selectedIndex != 0) {
          checkIcon.classList.remove('hidden');
        }
      },
      displayProductCategoryBlock(elementIdName) {
        const categorySelect = document.getElementById(elementIdName);
        const categoryId = categorySelect.value;

        if(!categoryId) { return; }

        axios.get(`/pix/api/public/product_category_label?category_id=${categoryId}`).then(
          (res) => {
            const productCategoryLabel = res.data.product_category_label;

            if(productCategoryLabel == ''){
              const productCategoryBlock = Rails.$('.product_category')[0];

              if(!productCategoryBlock.classList.contains('hidden')){
                productCategoryBlock.classList.add('hidden');
              }

              [0, 1, 2, 3].forEach(
                (i) => {
                  Rails.$(`#productCategorySelect${i}`)[0].classList.remove('required');
                  Rails.$(`#productCategorySelect${i}`)[0].value = '';
                  Rails.$(`#productCategorySelectBlock${i}`)[0].classList.add('hidden');
                }
              );

              return;
            }

            setTimeout(() => {
              Rails.$('.product_category')[0].classList.remove('hidden');
              Rails.$(`#productCategorySelectBlock0`)[0].classList.remove('hidden');
            }, 5);

            Rails.$(`#productCategoryLabel`)[0].innerText = productCategoryLabel;
            Rails.$(`#productCategorySelect0`)[0].classList.add('required');

            this.fetchProductCategories0(categoryId);
          }
        );
      },
      fetchProductCategories0(categoryId){
        LoadingAnimation.startWaitingSpinner();
        axios.get(`/pix/api/public/product_categories?category_id=${categoryId}`).then(
            (res) => {
              if(res.data.length > 0){
                productCategoryVm.productCategories0 = [{id: '', name: '選択してください'}].concat(res.data);
                const productCategorySelect0 = Rails.$('#productCategorySelect0')[0];
                productCategorySelect0.selectedIndex = 0;

                // LP2画面のみ実行する
                NextFieldHint.addProductCategorySelectBlock('0');

                const defaultValue = productCategorySelect0.getAttribute('default-value');
                if(defaultValue) {
                  productCategoryVm.fetchProductCategories1(defaultValue);
                  productCategorySelect0.setAttribute('default-value', '');
                }
              }
              LoadingAnimation.endWaitingSpinner();
              // axios完了時点で productCategorySelect0 の value/required が変化しているので
              // 送信ボタンの活性状態を再評価する
              window.updateButtonByCheckAllRequiredValues();
            }
          );
      }
    },
    mounted(){
      if (this.$refs.parentCategory){
        this.loadChildCategories();

        const selectedParentCategoryLabel = this.getSelectedParentLabel();
        this.toggleItemImageRequired(selectedParentCategoryLabel);
        setTimeout(() => {
          const selectedChildCategoryLabel = this.getSelectedChildLabel();
          this.toggleModelNumberField(selectedParentCategoryLabel, selectedChildCategoryLabel);
          this.toggleUserTelRequired(selectedParentCategoryLabel, selectedChildCategoryLabel);
        }, 5);
      } else {
        this.displayProductCategoryBlock('item_child_category_id');
      }
    },
    updated(){
      // 子カテまで選択された状態でくると、タイミングの問題で
      // 電話番号の必須・任意切り替えと型番のチェック時に
      // 子カテが選択されていないのでupdated()でもチェックをする
      const selectedParentCategoryLabel = this.getSelectedParentLabel();
      const selectedChildCategoryLabel = this.getSelectedChildLabel();
      const selectedCategoryShortName = this.getSelectedChildShortName() || this.getSelectedParentShortName();
      this.toggleUserTelRequired(selectedParentCategoryLabel, selectedChildCategoryLabel);
      this.toggleModelNumberField(selectedParentCategoryLabel, selectedChildCategoryLabel);
      this.toggleFashionCategoryNote(selectedCategoryShortName);
      this.displayProductCategoryBlock('item_parent_category_id');
      this.displayProductCategoryBlock('item_child_category_id');
      this.displayCheckIcon();
      jQuery('.selmodal').selModal();
    }
  });
});

window.addEventListener('load', () => {
  const chatSubmit = document.getElementsByClassName('question_submit')[0];
  if(chatSubmit) {
    chatSubmit.onclick = (function() {
      const message_field = Rails.$('.textarea_quenstion_comment')[0];
      if(message_field.value.length === 0) {
        return false;
      } else {
        Rails.disableElement(chatSubmit);
        questionForm.submit(); // FIXME: 定義されていない？
      }
    });
  }
});

window.addEventListener('load', () => {
  const modelNumberField = document.getElementById('item_model_number');
  if(!modelNumberField) { return; }

  modelNumberField.addEventListener('keydown', () => {
    AutoInputItemName.buildItemNameValue();
  });
});

window.addEventListener('load', () => {
  if (window.location.pathname == '/pix/items' && window.location.hash == '') {
    window.location = `${window.location.href}#form_validated`;
  }
});

window.addEventListener('load', () => {
  if(!Rails.$('#startEditNote')) {return;}

  jQuery('#startEditNote').on('click', () => {
    jQuery('#noteForm').removeClass('hidden');
    jQuery('#startEditNote').addClass('hidden');
    jQuery('#note').addClass('hidden');
  });

  jQuery('#cancelEditNote').on('click', () => {
    jQuery('#noteForm').addClass('hidden');
    jQuery('#startEditNote').removeClass('hidden');
    jQuery('#note').removeClass('hidden');
  });

  jQuery('#submitNote').on('click', () => {
    jQuery('#hiddenSubmit').click();
    jQuery('#saveMemoNotice').show();
  });

  jQuery('#note').on('keyup', () => {
    jQuery('#saveMemoNotice').hide();
    jQuery('#saveMemoNoticeEx').hide();
  });
});

window.addEventListener('load', () => {
  const $trigger = jQuery('.shipping_cost_detail_trigger');
  $trigger.on('click', () => {
    jQuery('.shipping_cost_detail').toggle();
    if($trigger.text() === '▼条件を見る' ){
      $trigger.text('▲閉じる');
    }else{
      $trigger.text('▼条件を見る');
    }
  });
});

window.addEventListener('load', () => {
  const saveButton = jQuery('.save_search_condition_history');
  const path = '/pix/pro/search_condition_histories';

  saveButton.on('click', () => {
    const searchForm = jQuery('.freeword-search-form > form');
    const historyForm = jQuery('.search_condition_history');
    const authenticityToken = historyForm.find('[name="authenticity_token"]');

    searchForm.attr('action', path);
    searchForm.attr('method', 'post');
    searchForm.append(`<input type="hidden" name="query_string" value="${searchForm.serialize()}">`);
    searchForm.append(authenticityToken);
    searchForm.submit();
  });
});

window.addEventListener('load', () => {
  const modalCategorySelect = jQuery('.pro-item-category-select');
  const searchFormCategoryHidden = jQuery('#search_category_id');

  // 買い手商品検索でモーダルカテゴリの方を選択した時に、検索フォームのhiddenに値をセットする
  modalCategorySelect.on('change', function() {
    searchFormCategoryHidden.val(jQuery(this).val());
  });
});

import offRadioButton from './off_radio_button';
window.addEventListener('load', () => {
  const biddingRadioInTrouble = $('#bidding_radio_in_trouble');
  const notSatisfactionRadios = $('.not-satisfaction_radios');

  $('#bidding_in_trouble').on('click', () => {
    const isChoiceBiddingRadioInTrouble = document.getElementById('bidding_radio_in_trouble').classList.contains('color');
    if (isChoiceBiddingRadioInTrouble) {
      notSatisfactionRadios.addClass("hide");
    } else {
      notSatisfactionRadios.removeClass("hide");
    }
    biddingRadioInTrouble.toggleClass("color");
    offRadioButton();
  });

  $('#bidding_is_progress').on('click', () => {
    biddingRadioInTrouble.removeClass("color");
    notSatisfactionRadios.addClass("hide");
  });
});

require('jquery-jpostal-ja');
window.addEventListener('load', () => {
  jQuery('#user_postal_code').jpostal({
    postcode : [
      '#user_postal_code',
    ],
    address : {
      '#user_prefecture_id' : '%3',
      '#user_city_address' : '%4',
      '#user_street_address' : '%5'
    }
  });
});

window.addEventListener('load', () => {
  specialCampaignTxtResizeFont();
  $('.present_detail_more').on('click', function () {
    $(this).hide();
    $(this).next().slideToggle();
    $(this).toggleClass("selected");
  });
});

window.addEventListener('resize', () => {
  specialCampaignTxtResizeFont();
});

// 大手送客のキャンペーン対象企業名を1行に文字列を収める処理
function specialCampaignTxtResizeFont() {
  const textElem = document.getElementById("special_campaign_organizations");
  if (textElem) {
    textElem.removeAttribute('style');
    for (
      let size = 14;
      textElem.scrollHeight > Number(getComputedStyle(textElem).getPropertyValue('line-height').replace("px",""))+5 && size > 1;
      size--
    ) {
      textElem.style.fontSize = `${size}px`;
    }
  }
}
